<template>
	<div class="calculation-input">
		<div class="variable-label">
			<span class="latex-title" v-html="checkKatexValue(input.displayName || input.latex_title)"></span>
			<span class="latex-unit" v-html="checkKatexValue(input.latex_unit)"></span>
			<!-- <span class="title" v-if="input.title">({{ input.title }})</span> -->
		</div>

		<template v-if="input.kind == 'user_input' || displayOnly" >
			<div class="calc-input-group">
				<input v-model="data" :disabled="displayOnly" @input="localChange" type="text">
				<Tooltip :text="input.helpText"/>
			</div>
		</template>
		<template v-else-if="input.kind == 'table_entry' && 'export' in input.value">
			<TableIframe
				class="variable-table"
				v-if="tableLoaded"
				:selectable="input.value.parameter"
				:selected-value="data"
				:table-loop-key="table.loopKey"
				:item-data="input" :item-key="id"
				:parameters="table.parameters"
				:rows="table.rows"
				:values="table.values"
				:get-next-table-position="getNextTablePosition"
				:has-next-parameter-position="table.hasNextParameterPosition"
				:has-next-cols="table.hasNextCols"
				:rows-per-position="table.rowsPerPosition"
				:parameters-per-position="table.parametersPerPosition"
				:row-position="table.rowPosition"
				:parameter-position="table.parameterPosition"
				:select-value="localTableChange"
				@update-row-position="localTableChange"
				@update-parameter-position="localTableChange"
				/>

		</template>
		<template v-else-if="input.kind == 'table_entry' && !('export' in input.value)">
			<div class="value-dropdown">
				<button class="dropbtn">
					<span v-if="data">{{dropdownTitle}}</span>
					<span v-else>Nothing selected</span>
				</button>
				<div class="dropdown-content">
					<span v-for="(value, id) in dropdown" :key="id" @click="localDropdownChange(id)">{{value.value}}</span>
				</div>
			</div>
		</template>

		<div class="calc-error-msg" v-show="hasError">
			<span v-html="input.inputRuleText"></span>
		</div>

		
	</div>
</template>

<script>
import TableIframe from "./TableIframe.vue";
import Tooltip from './Tooltip.vue';

// import prepareForm from '@/services/prepare-formdata';

// import { languageLoader } from '@/language/getter';

import {
    mapActions
} from 'vuex';

export default {
	name: "CalculationInput",
	components: {
		TableIframe,
		Tooltip
	},
	props: {
		input:{
			type:Object,
			default:()=>({})
		},
		id:{
			type:String,
			default:()=>'some_id'
		},
		changeFN: Function,
		displayOnly:{
			type:Boolean,
			default:false
		},
        computedCalculationId: {
            type: String,
            default: ''
        }
	},
	data() {
		return {
			data:null,
			hasError:false,
			tableLoaded:false,
			table:{},
			dropdown:{}
		}
	},
	computed: {
		dropdownTitle(){
			if(this.data && this.dropdown){
				return this.dropdown[this.data].value
			}else return ''
		}
	},
	methods: {
		...mapActions('table', ['getParameterData','getTableIframeData','getTableHeader']),
		localDropdownChange(id){
			this.data = id
			this.localChange()
		},
		localTableChange(id){
			this.data = id
			this.localChange()
		},
		localChange(){
			if(this.input.kind != 'user_input'){
				this.changeFN(this.data,this.id)
			}else if(this.inputRule()){
				this.changeFN(this.data,this.id)
			}else if(this.data){
				this.hasError = true;
				setTimeout(()=>{
					this.hasError = false
				}, 3000)
			}
		},
		inputRule(){
			if(this.input.inputRule && this.data){
				let calcStr = `${this.input.inputRule}`;
				calcStr = calcStr.replace(this.input.title, this.data)
				try{
					return new Function(` return ${calcStr}`)()
				}catch(e){
					console.error('error executing input rule', this.input.inputRule, calcStr)
					return false
				}
			}else if(this.data){
				return true
			}else return false
		},
		checkKatexValue(value) {
			if (value && typeof value === 'string') {
				return this.$katex.renderToString(value, {
					throwOnError: false,
				});
			}
			return '';
		},
		getTableIframeDataFN(data) {
			return this.getTableIframeData(data).then(res => {
				this.table.loopKey = Date.now();
				this.table.values = res.data.values
				this.table.rowsPerPosition = res.data.display.rows
				this.table.parametersPerPosition = res.data.display.columns
				if (res.data.loadedRows < 15) {
					this.table.hasNextParameterPosition = true
				} else {
					this.table.hasNextParameterPosition = false
				}

				if (Object.keys(res.data.values).length >= 11) {
					this.table.hasNextCols =  true

				} else {
					this.table.hasNextCols = false
				}
				this.tableLoaded = true;
			})
			.catch(err => console.log(err));
		},
		getTableIframeHeaderFN(exportId) {
			return this.getTableHeader({
				id: exportId,
				calc: this.computedCalculationId
			}).then(res => {
				if(res.success){
					this.table.rows = res.data?.rowKeys
					this.table.parameters = res.data?.parameters
					this.getTableIframeDataFN({
						id: this.input.value.export,
						parameterPosition: this.table.parameterPosition || 1,
						rowPosition: this.table.rowPosition || 1,
						calc: this.computedCalculationId
					});
				}
			}).catch(err => console.log(err));
		},
		getNextTablePosition(position, variable) {
			this.getTableIframeData({
				id: variable.value.export,
				parameterPosition: position.parameterPosition,
				rowPosition: position.rowPosition
			}).then(res => {
				console.log(res)
			})
			.catch(err => console.log(err))
		},
		getParameterDataFN(query) {
			this.getParameterData(query).then(res => { 
				this.dropdown = res.data.data
			}).catch(err => console.log(err));
		},
	},
	mounted() {
		if(this.input.kind == 'table_entry' && this.input.value.export){
			this.data = this.input?.value.selectedValue
			this.getTableIframeHeaderFN(this.input.value.export)
		}else if(this.input.kind == 'table_entry'){
			this.data = this.input?.value.selectedValue
			this.getParameterDataFN({
				tableId: this.input.value?.table,
				paramId: this.input.value?.parameter,
				calc: this.computedCalculationId
			})
		}else{
			this.data = this.input?.value
		}
	},
	watch: {}
}
</script>

<style lang="scss" scoped>
.calc-input-group {
	position: relative;

	input {
		padding: 10px;
		width: calc(100% - 52px);
		border: 1px solid #ddd;
		border-radius: 4px;
	}
	::v-deep .tooltip-wraper{
		right: 0;
		top: 4px;
		width: 35px;
		height: 35px;
		border-radius: 23px;
	}
}



/* The container <div> - needed to position the dropdown content */
.value-dropdown {
	position: relative;
	border-radius: 4px;
	&:hover{
		.dropdown-content {
			display: block;
		}
		.dropbtn {
			background-color: #79a5c0;
		}
	}
	.dropbtn {
		background-color: #9ec7e0;
		color: white;
		padding: 10px;
		width:100%;
		font-size: 16px;
		border: none;
		border-radius:3px;
	}
	.dropdown-content {
		display: none;
		position: absolute;
		background-color: #f1f1f1;
		min-width: 160px;
		box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
		z-index: 1;
		span {
			color: black;
			padding: 12px 16px;
			text-decoration: none;
			display: block;
			&:hover {
				background-color: #ddd;
			}
		}
	}
}
.variable {
    position: relative;

    &-input {
        ::v-deep {
            .formulate-input-label {
                font-weight: 400;
                color: #B0AFB5;
                font-size: 1rem;
                margin-bottom: 10px;
                min-height: 26px;
                padding-right: 30px;
            }
        }
    }

    &-label {
        font-weight: 400;
        color: #B0AFB5;
        font-size: 1rem;
        margin-bottom: 10px;
        min-height: 26px;
        padding-right: 30px;

        // .latex-title {}
        .latex-unit {
            margin-left: 15px;
            color: #FCBD01;
        }

        .title {
            display: inline-block;
            margin-left: 15px;
            color: #2D2E30;
        }
    }

    &__text {
        margin-bottom: 10px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}

</style>
